import {
  Component,
  inject,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { Store } from '@ngrx/store';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import {
  ConversationSenderTypes,
  getTranslationLoaded,
  I18nService,
  InitCookiesPreference,
  LoadingSpinnerComponent,
  ModalService,
  NewRelicService,
  NewUpdateBannerComponent,
  ScrollerDirective,
  ScrollerService,
  SetSender,
  ThemeDirective,
  ThemeService,
  ToastService,
  UpdateApplicationSuccess
} from '@ui/legacy-lib';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { ENVIRONMENT_CONFIG } from './core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    LoadingSpinnerComponent,
    RouterOutlet,
    ThemeDirective,
    ScrollerDirective,
    AsyncPipe
  ]
})
export class AppComponent implements OnInit {
  public finishedLoaded$: Observable<boolean>;
  private store = inject(Store);
  private i18nService = inject(I18nService);
  private viewContainerRef = inject(ViewContainerRef);
  private toastService = inject(ToastService);
  private scrollerService = inject(ScrollerService);
  private themeService = inject(ThemeService);
  private environment = inject(ENVIRONMENT_CONFIG);
  private newRelicService = inject(NewRelicService);
  private swUpdate = inject(SwUpdate);
  private modalService = inject(ModalService);

  constructor() {
    this.toastService.setRootViewContainerRef(this.viewContainerRef);
    this.i18nService.loadDefaultTranslations();
    this.scrollerService.enableAllRoutes();
    this.newRelicService.init();

    this.finishedLoaded$ = this.store.select(getTranslationLoaded);
    this.store.dispatch(
      new SetSender(ConversationSenderTypes.PROPERTYSEARCHER)
    );
    this.themeService.init(this.environment);
  }

  public ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'
          )
        )
        .subscribe(() =>
          this.modalService
            .open(NewUpdateBannerComponent, {
              backdrop: 'static'
            })
            .onClose()
            .subscribe(() =>
              this.store.dispatch(new UpdateApplicationSuccess())
            )
        );
    }

    this.store.dispatch(new InitCookiesPreference());
  }
}
